import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getCalendarAuthDetailsV2 } from 'services/plugins';

export const useCalendarAuthDetails = ({ authStatusFetched }) =>
  useQuery([REACT_QUERY_KEYS.settings.oneOnOne.SettingsOneOnOneCalendarAuth, authStatusFetched], () =>
    getCalendarAuthDetailsV2()
  );
